import { z } from 'zod';
import { SignInType } from '../types/enums.js';
export const recordSignInSchema = z.object({
    workerId: z.string().uuid(),
    projectId: z.string().uuid().nullable().optional(),
    type: z.nativeEnum(SignInType),
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    accuracy: z.number().min(0),
    device: z.string().nullable().optional(),
});
//# sourceMappingURL=signin.js.map